import { InjectionToken } from '@angular/core';

export type EnvName = 'local' | 'dev' | 'staging' | 'prod';

export const ENV_NAME = new InjectionToken<EnvName>('Environment Name', {
  factory: () => 'local',
});
